module.exports = __webpack_public_path__ + "static/flags/AM-59dcce2025a08fac07e8de5a52b0b4b6.gif";